import { VerticalSpacer } from '@superhi/design'
import { useRouter } from 'next/router'
import React from 'react'

import {
  TranscriptParagraph,
  TranscriptParagraphTime,
  TranscriptParagraphText,
  TranscriptParagraphLine,
} from './styles'
import { createTranscript } from './utils'

interface Props {
  children: any
}

export const Transcript: React.FC<Props> = ({ children }) => {
  const router = useRouter()
  const formattedLines = React.useMemo<ReturnType<typeof createTranscript>>(() => {
    try {
      return createTranscript(children)
    } catch (e) {
      console.log(e)
    }

    return [] as never as ReturnType<typeof createTranscript>
  }, [children])

  return (
    <VerticalSpacer amount={{ small: 24, medium: 24, large: 24 }} data-component-name="Transcript">
      {formattedLines.map((paragraph, i) => (
        <TranscriptParagraph key={i}>
          <TranscriptParagraphTime>{paragraph.displayTime}</TranscriptParagraphTime>
          <TranscriptParagraphText>
            {paragraph.lines.map((line) => (
              <TranscriptParagraphLine
                key={line.id}
                onClick={() =>
                  router.replace(
                    {
                      pathname: router.pathname,
                      query: { ...router.query, t: line.start.toString() },
                    },
                    undefined,
                    {
                      shallow: true,
                      scroll: true,
                    },
                  )
                }
              >
                {line.line}
              </TranscriptParagraphLine>
            ))}
          </TranscriptParagraphText>
        </TranscriptParagraph>
      ))}
    </VerticalSpacer>
  )
}

export default Transcript
